export const getFurnitureDT = state => state.furniture.furnitureDT;